import React, { FC, useCallback, useEffect } from 'react';

import {
  CategoryPreferences,
  CookiesConsent,
  DestinationCategory,
  loadAnalytics,
} from '../cookies-consent';
import { loadSmartlook } from '../smartlook';
import { contextEnrichment } from './ad-params-plugin';
import { useCookiesConsent } from './Context';

interface ConsentManagerProps {
  writeKey?: string;
  locale: string;
}

export const ConsentManager: FC<ConsentManagerProps> = ({
  writeKey,
  locale,
}) => {
  const { forcedOpen, setForcedOpen } = useCookiesConsent();

  const onCookiesAccept = useCallback(
    (selection: CategoryPreferences | boolean) => {
      setForcedOpen(false);

      if (typeof selection === 'boolean' && selection === false) return;
      if (selection === true || selection[DestinationCategory.ANALYTICS]) {
        loadSmartlook();
      }
    },
    [],
  );

  useEffect(() => {
    if (!writeKey) return;
    loadAnalytics([contextEnrichment]);
  }, [writeKey]);

  if (!writeKey) return null;

  return (
    <CookiesConsent
      forcedOpen={forcedOpen}
      writeKey={writeKey}
      language={locale}
      onCookieAccept={onCookiesAccept}
    />
  );
};
